export { default } from './ButtonPaywall';
